import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from "react";
import "react-notifications-component/dist/theme.css";
import { Col, Container, Row } from "reactstrap";
import { showAlert } from "../common/functions";
import RatingSettingDetail from "./ratingSettingDetail";

class RatingSettingPage extends React.Component {
	componentDidMount() {
		var alertMessage = window.localStorage.getItem("alertMessage");
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem("alertMessage", "");
		}

		document.title = "Rating Settings - Daily Audio Bible Administration";
	}

	render() {
		return (
			<div>
				<Container>
					<Row>
						<Col lg="12">
							<div>
								<h2>
									{/* <FontAwesomeIcon icon={faStar} /> */}
									<span data-testid="ratingSettingPageTitle">
										{" "}
										Rating Settings
									</span>
								</h2>
								<hr />
								<RatingSettingDetail />
							</div>
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default RatingSettingPage;